import { render, staticRenderFns } from "./certifiedLaboratory.vue?vue&type=template&id=d30e3b86&scoped=true&"
import script from "./certifiedLaboratory.vue?vue&type=script&lang=js&"
export * from "./certifiedLaboratory.vue?vue&type=script&lang=js&"
import style0 from "./certifiedLaboratory.vue?vue&type=style&index=0&id=d30e3b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30e3b86",
  null
  
)

export default component.exports